module.exports = __webpack_public_path__ + "static/cohete-845ba57a506123e1f8e4ef24301a5e8f.svg";